<div class="profile-container">
    <div class="">
      <div class="profile-content">
        <!-- <div class="personal-details">
          <h4 class="personal-details-title">Tax Master List</h4>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">TaxId</th>
                <th scope="col">Name</th>
                <th scope="col">Amount</th>
                <th scope="col">Percentage</th>                
                <th scope="col">Description</th> 
                <th scope="col">Created Date</th>                            
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tax of taxMasterList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count};let i = index">
                <th>{{tax.taxMasterId}}</th>
                <th>{{tax.name}}</th>
                <th>{{tax.amount}}</th>
                <th>{{tax.percentage}}</th>
                <th>{{tax.description}}</th>
                <th>{{tax.createdDate | date}}</th>

                <th>
                  <i class="bi bi-eye-fill" (click)="getTaxMasterById(tax.taxMasterId)" data-toggle="modal" data-target="#exampleModalView" ></i>
                </th>
              </tr>
            </tbody>
          </table>
          <div class="pagination-block" *ngIf="taxMasterList.length != 0">
            <pagination-controls
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
          </div>
        </div> -->

        <div class="personal-details">

          <div class="header-block">
              <div class="header-title">
                  <p>Tax Master List</p>
              </div>
              <div class="add-block">
                <div class="search">
                  <form autocomplete="off" >
                      <input [ngModelOptions]="{standalone: true}" placeholder="search user" [(ngModel)]="searchKey"/>
                  </form>
                  <i class="bi bi-x-lg" (click)="refreshSearch()" *ngIf="searchKey != ''"></i>

                  <i class="bi bi-search" (click)="getAllTaxMasterByWildSearch(0,10)"></i>
                </div>
                  <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
              </div>
          </div>
        
          <table class="table table-striped">
              <thead>
                  <tr>
                    <th style="width: 20%;">Name</th>
                    <th style="width: 10%;">Amount</th>
                    <th style="width: 15%;">Percentage</th>                
                    <th style="width: 25%;">Description</th> 
                    <th style="width: 15%;">Created Date</th>                            
                    <th style="width: 15%;text-align: center;padding: 0;" class="">Action</th>
                  </tr>
              </thead>
          </table>
          <div *ngIf="!isLoading">
              <div class="data-view" *ngFor="let tax of taxMasterList | paginate : {
                  itemsPerPage: recordsPerPage,
                  currentPage: pageNumber,
                  totalItems: totalRecords
                  }  ;let i = index">
  
                  <p style="width: 20%;">{{tax.name}}</p>
                  <p style="width: 10%;">{{tax.amount}}</p>
                  <p style="width: 15%;">{{tax.percentage}}</p>
                  <p style="width: 25%;">{{tax.description}}</p>
                  <p style="width: 15%;">{{tax.createdDate | date}}</p>
                
                  <p class="action-buttons" style="width: 15%;padding-left: 25px;">
                    <i *ngIf="actionControls.isModify" class="bi bi-pencil-square" (click)="getTaxMasterById(tax.taxMasterId)" data-toggle="modal" data-target="#editModalView" ></i>

                    <i *ngIf="actionControls.isDelete" data-toggle="modal" data-target="#deleteModal" (click)="selectTaxMaster(tax.id)" class="bi bi-trash3"></i>
                  </p>
              </div>
          </div>
  
  
          <div class="loader" *ngIf="isLoading">
              <div class="spinner"></div>
          </div>
  
          <div class="loader"  *ngIf="!isLoading && taxMasterList.length == 0">
              <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
              </div>
              
          </div>
  
          <div class="paginator">
              <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="recordsPerPage" [totalRecords]="totalRecords"
                [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
              </p-paginator>
          </div>
  
    
      </div>
      </div>
    </div>
</div>



<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>are you sure? want to delete??</p>   
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="deleteTaxMaster()" class="btn btn-primary">Delete</button>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Tax Master
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="taxForm">
          <div class="row">
              <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                      <label>Name </label>
                      <input type="text" formControlName="name" class="form-control" placeholder="">
                  </div>
              </div>

              <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                      <label>Amount </label>
                      <input type="text" formControlName="amount" class="form-control" placeholder="">
                  </div>
              </div>

              <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                      <label>Percentage </label>
                      <input type="text" formControlName="percentage" class="form-control" placeholder="">
                  </div>
              </div>

              <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                      <label>Description </label>
                      <textarea class="form-control" formControlName="description" name="" id="" cols="30" rows="3"></textarea>
                  </div>
              </div>
      

              
          </div>
      </div>  
      </div>
      <div class="modal-footer">
        <button type="button" id="closeModalButton4" class="btn btn-secondary" data-dismiss="modal">Cancel</button>

          <button class="btn btn-primary" *ngIf="!addButton" (click)="addTaxMaster()">Submit</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editModalView" tabindex="-1"  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Update Privilege
                <span data-dismiss="modal">
                  <i class="bi bi-x-lg"></i>
                </span>
              </h5>
          </div>
          <div class="modal-body">
  
            <div [formGroup]="updateTaxForm">
              <div class="row">
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Name </label>
                          <input type="text" formControlName="name" class="form-control" placeholder="">
                      </div>
                  </div>

                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Amount </label>
                          <input type="text" formControlName="amount" class="form-control" placeholder="">
                      </div>
                  </div>

                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Percentage </label>
                          <input type="text" formControlName="percentage" class="form-control" placeholder="">
                      </div>
                  </div>

                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Description </label>
                          <textarea class="form-control" formControlName="description" name="" id="" cols="30" rows="3"></textarea>
                      </div>
                  </div>
          

                  <div class="col-md-12 col-lg-12 submit-b">
                    <button type="button" id="closeModalButton3" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button class="btn btn-primary" *ngIf="!addButton" (click)="editTaxMaster()">Submit</button>
                  </div>
              </div>
          </div> 
          </div>
      </div>
  </div>
  </div>